import api from '../axiosInstance';
import { ANALYTICS_ENDPOINTS } from '../constants';

export const getCustomerUsageAnalytics = (compId) => {
  return api.get(ANALYTICS_ENDPOINTS.CUSTOMER_USAGE_LOWEST(compId));
}

export const getCustomerUsageLastMsg = (compId) => {
  return api.get(ANALYTICS_ENDPOINTS.CUSTOMER_LAST_USAGE(compId));
}